import { render, staticRenderFns } from "./BankAccountLogs.vue?vue&type=template&id=5ce2def1&scoped=true&"
import script from "./BankAccountLogs.vue?vue&type=script&lang=js&"
export * from "./BankAccountLogs.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountLogs.vue?vue&type=style&index=0&id=5ce2def1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2def1",
  null
  
)

export default component.exports